import { render, staticRenderFns } from "./bargainingOrder.vue?vue&type=template&id=7ddca202&scoped=true"
import script from "./bargainingOrder.vue?vue&type=script&lang=js"
export * from "./bargainingOrder.vue?vue&type=script&lang=js"
import style0 from "./bargainingOrder.vue?vue&type=style&index=0&id=7ddca202&prod&lang=less&scoped=true"
import style1 from "./bargainingOrder.vue?vue&type=style&index=1&id=7ddca202&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddca202",
  null
  
)

export default component.exports